// 確認の画面（studio.md 7章・quiz-production.md 6章）：合格・直して合格・不合格（2026-10-09 差し戻しと保留はなくした）
import { z } from 'zod';
import { REJECT_TAGS } from './production';

const tagIds = REJECT_TAGS.map((t) => t.id) as [string, ...string[]];
/** 不合格の理由のタグ（任意。作問の指示を直すのに使う） */
const tags = z.array(z.enum(tagIds)).max(8).default([]);
const comment = z.string().trim().max(1000).default('');

/** 確認中のロック（30分操作がなければ自動で戻る） */
export const REVIEW_LOCK_MINUTES = 30;

export const ReviewStampBody = z.object({
  durationMs: z.number().int().min(0).max(3_600_000).optional(),
  /** 修正して承認（管理者だけ）：直した箇所は改善の教材として残す */
  edit: z
    .object({
      text: z.string().trim().min(1).max(300).optional(),
      answer: z.string().trim().min(1).max(60).optional(),
      answerAlts: z.array(z.string().trim().min(1).max(60)).max(10).optional(),
      explanation: z.string().max(1000).optional(),
    })
    .optional(),
});
/**
 * 確認一覧でまとめて判定する（2026-10-09）。問題と解答の確認待ちは pass＝合格・fail＝不合格、
 * 音声確認待ちは pass＝音声を採用（収録可）・fail＝不採用（クイズごと外す）・redo＝音声を作り直す。
 * 承認済み（音声なし）は audio＝音声を生成（API を使うのはここだけ。2026-10-09）、cancelAudio＝音声を作るのをやめる（2026-10-10）
 * rework＝収録していない収録可のクイズを、未確認に戻して作り直す（版が上がり、承認と音声はやり直し。2026-10-10）
 * unapprove＝承認済み（音声なし・音声を作っている待ち）のクイズを、未確認に戻す（版が上がり、承認はやり直し。2026-10-13）
 * part＝作り直す音声（redo のとき）：両方・問題だけ・答えだけ（2026-10-11）
 */
export const AUDIO_PARTS = ['both', 'question', 'answer'] as const;
export type AudioPart = (typeof AUDIO_PARTS)[number];
export const ReviewBulkBody = z.object({ ids: z.array(z.uuid()).min(1).max(100), action: z.enum(['pass', 'fail', 'redo', 'audio', 'cancelAudio', 'rework', 'unapprove']), part: z.enum(AUDIO_PARTS).default('both'), tags, comment });
/** 不合格：理由のタグとコメントは任意 */
export const ReviewRejectBody = z.object({ tags, comment, durationMs: z.number().int().min(0).max(3_600_000).optional() });

/** 判定の名前（前の版の差し戻し・保留・そのまま戻すは記録の表示のため残す） */
export const REVIEW_ACTION_LABEL = { stamp: '合格', return: '差し戻し', reject: '不合格', hold: '保留', restore: 'そのまま戻す', fix: '直して合格' } as const;
